import getAPIResponse from "Shared/Utils/Domain/Services/GetAPIResponsePrivateService";
import { GetServiceContactDelegationList } from "DelegationService/DelegationService/Domain/Responses/ServiceContactDelegation/GetServiceContactDelegationList";

export async function getContactsFromContractDelegationService(id) {
    let response = await getAPIResponse("/v1/service-contacts-from-contracts-delegation/" + id);
    console.log("DEBUG: respuesta cruda del backend:", response);

    if (!response) {
        return null;
    }

    let getServiceContactDelegationList = GetServiceContactDelegationList.createFromResponseData(response);

    console.log("DEBUG: objeto procesado:", getServiceContactDelegationList);

    return getServiceContactDelegationList;
}